/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    inProgress: false,
    errors: null
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'LOGIN_PAGE_UNLOADED':
            return {};
        case 'ASYNC_START':
            if (action.subtype === 'LOGIN') {
                return { ...state, inProgress: true };
            }
            break;
    }

    return state;
};